import { AxiosResponse } from "axios";
import api from "../api";

export const setupMy529OtherInvestmentOptions = async () => {
  return await api.get("/Utah/InvestmentOptions");
};

/* export const fetchInvestmentOptions = async () => {
  return await api.get(`/getInvestmentOptions`);
}; */

export const fetchInvestmentOptions = async () => {
  return await api.get(`/Account/getInvestmentOptions`);
};

export const getReferenceTable = async () => {
  return await api.get("/Reference/referenceTable");
};

export interface InvestmentOption {
  minorAccountID: string;
  userAccountID: string;
  investmentOptionID: number;
  investmentOptionName: string;
  changeReason: string;
}

export interface UtahApplicationParams {
  minorAccountID: string;
  investmentOption: string;
}

export interface AuthParams {
  userAccountID: string;
}

export interface UtahApplicationResponse {
  Success: boolean;
  Message: string;
}

export const UtahApplication = async (
  data: UtahApplicationParams,
  auth: AuthParams,
): Promise<AxiosResponse<UtahApplicationResponse>> => {
  if (!data || !auth || !auth.userAccountID) {
    throw new Error("UtahApplication: Missing required parameters");
  }

  const addressBody = {
    StreetAddress1: null,
    StreetAddress2: null,
    City: null,
    State: null,
    ZipCode: null,
    CountryCode: null,
  };

  return await api.post<UtahApplicationResponse>("/Utah/Application", {
    UserAccountID: auth.userAccountID,
    ModifyingUserAccountID: auth.userAccountID,
    MinorAccountID: data.minorAccountID,
    ApplicationStatus: "ApplicationSubmittedFromCustomer",
    InvestmentOption: data.investmentOption,
    My529AccountNumber: "",
    IsMy529AccountForMySelf: false,
    IsMy529DelegatedToMySelf: false,
    IsAddressSameAsParent: true,
    SourceProcess: "WebApplication",
    ChangeReason: "Utah Application",
    ...addressBody,
  });
};

/* export const insertInvestmentOption = async (
  userAccountID: string,
  minorAccountID: number,
  employeeID: string,
  sootchyEmployerID: string,
  investmentOption: string
) => {
  const formatedData = {
    userAccountID: parseInt(userAccountID),
    minorAccountID: minorAccountID,
    employeeID: employeeID,
    sootchyEmployerID: parseInt(sootchyEmployerID),
    investmentOption: investmentOption,
    createdUserAccountID: parseInt(userAccountID),
    sourceProcess: "WebApplication",
    changeReason: "Save Investment Option",
  };

  return api.post(`/Employee/InvestmentOption`, formatedData);
}; */

export const insertInvestmentOption = async (data: unknown[]) => {
  return api.post(`/Employee/SaveInvestmentOptions`, data);
};
